import { render, staticRenderFns } from "./ProjectNewForm.vue?vue&type=template&id=354c4fad&"
import script from "./ProjectNewForm.vue?vue&type=script&lang=js&"
export * from "./ProjectNewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports